import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginSectionComponent } from './login-section/login-section.component';
import { FindYourAccountComponent } from './find-your-account/find-your-account.component';
import { ForgotEmailComponent } from './forgot-email/forgot-email.component';
import { OtpConfirmationScreenComponent } from './otp-confirmation-screen/otp-confirmation-screen.component';
import { PasswordVerificationSuccessPopupComponent } from './password-verification-success-popup/password-verification-success-popup.component';
import { PhOtpVerificationComponent } from './ph-otp-verification/ph-otp-verification.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { EmailOtpVerificationComponent } from './email-otp-verification/email-otp-verification.component';


const routes: Routes = [
{
  path: '',
  component: LoginSectionComponent,
},
{
    path: 'find-account',
    component: FindYourAccountComponent
  },
  {
    path: 'set-New-Password',
    component: SetNewPasswordComponent
  },
   {
    path: 'password-success-popup',
    component: PasswordVerificationSuccessPopupComponent
  },
    {
    path: 'forgot-email',
    component: ForgotEmailComponent
  },
    {
    path: 'email-otp-verification',
    component: EmailOtpVerificationComponent
  },
   {
    path: 'confirmation-screen',
    component: OtpConfirmationScreenComponent
  },
  {
    path: 'phonenumber-otp-verification',
    component: PhOtpVerificationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppLoginRoutingModule { }
